import styled from '@emotion/styled';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import COLORS3 from '@zola/zola-ui/src/styles/emotion/colors3';
import H from '@zola/zola-ui/src/typography/Headings';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const SummaryHeaderContainer = styled.div`
  border-bottom: 1px solid ${COLORS3.BLACK_030};
`;

export const TitlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 ${SPACING.LG} ${SPACING.S32};

  ${MEDIA_QUERY_V2.MOBILE} {
    padding: 0 ${SPACING.S24} ${SPACING.S32};
  }

  ${MEDIA_QUERY_V2.EXCLUDE_DESKTOP} {
    align-items: flex-start;
  }
`;

export const TopicLink = styled(LinkV2)`
  margin-bottom: ${SPACING.S16};
  ${MEDIA_QUERY_V2.EXCLUDE_DESKTOP} {
    display: none;
  }
`;

export const Title = styled(H.TitleAccent1)`
  font-weight: ${FONT.WEIGHT.MEDIUM};
  ${FONT.textSizeCompact(FONT.SIZE.LARGER)};
`;

export const SubtitleContainer = styled.div<{ truncated: boolean }>`
  display: ${({ truncated }) => (truncated ? 'flex' : null)};
  align-items: flex-end;
  margin-top: ${SPACING.S16};
  ${MEDIA_QUERY_V2.DESKTOP} {
    max-width: 688px;
    text-align: center;
  }
`;

export const Subtitle = styled(H.Title2, { shouldForwardProp: prop => prop !== 'truncated' })<{
  truncated: boolean;
}>`
  display: ${({ truncated }) => (truncated ? '-webkit-box' : 'inline')};
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const SubtopicChipsContainer = styled.div`
  ${MEDIA_QUERY_V2.MOBILE} {
    padding: 0 ${SPACING.S24} ${SPACING.S32};
  }

  ${MEDIA_QUERY_V2.TABLET} {
    padding: 0 ${SPACING.LG} ${SPACING.S32};
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    padding-bottom: ${SPACING.LG};
  }
`;
